"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var root = require("window-or-global");
function addToDataLayer(any) {
    if (root.dataLayer) {
        root.dataLayer.push(any);
    }
}
function sendEvent(category, action, label) {
    addToDataLayer({
        event: 'ga_event',
        eventCategory: category,
        eventAction: action,
        eventLabel: label
    });
}
exports.sendEvent = sendEvent;
//# sourceMappingURL=gtm.js.map